import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import shallowCompare from 'react-addons-shallow-compare'
import { select } from 'd3-selection'
import PropTypes from 'prop-types'

class D3RenderedComp extends Component {
  constructor() {
    super()
    this.renderD3Comp = this.renderD3Comp.bind(this)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState)
  }

  componentDidUpdate() {
    // console.debug('calling from update....');
    this.renderD3Comp()
  }

  componentDidMount() {
    // console.debug('calling from mount....');
    this.renderD3Comp()
  }

  renderD3Comp() {
    // console.debug('rendering axis....');
    const node = ReactDOM.findDOMNode(this)
    const { children, ...props } = this.props
    if (children) select(node).call(children(props))
  }

  render() {
    const { dx = 0, dy = 0 } = this.props
    const translate = `translate(${dx},${dy})`
    return <g className={this.props.className} transform={translate} />
  }
}

D3RenderedComp.propTypes = {
  dx: PropTypes.number,
  dy: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.func,
}

D3RenderedComp.defultProps = { dx: 0, dy: 0 }

export default D3RenderedComp
